/* eslint-disable no-param-reassign, consistent-return */
import {
  Droppable,
  Draggable,
} from '@hello-pangea/dnd';

import {
  Flex,
  Text,
} from 'web-styled';

import WeekHeader from './WeekHeader';
import WeekWorkouts from './WeekWorkouts';

type Props = {
  week: any,
  index: number,
  readOnly: boolean,
  resourceType: string,
  workoutOptions: any[],
  selectedWorkoutId: number,
  onCopy: { (): void },
  onUpdate: { (payload): void },
  onRemove: { (): void },
  onAddWorkout: { (option): void },
  onSelectWorkout: { (workout): void },
};

const Week = ({
  week,
  index,
  readOnly,
  resourceType,
  workoutOptions,
  onCopy,
  onUpdate,
  onRemove,
  onAddWorkout,
  onSelectWorkout,
  selectedWorkoutId,
}: Props) => (readOnly ? (
  <>
    <Flex
      width="100%"
      padding="10px"
      shrink="0"
      background="white"
    >
      <Text
        color="#797979"
        size="14px"
        weight="bold"
        nowrap
      >
        {week.name}
      </Text>
    </Flex>
    <WeekWorkouts
      readOnly
      workouts={week.workouts || []}
      selectedId={selectedWorkoutId}
      onSelectWorkout={onSelectWorkout}
    />
  </>
) : (
  <Draggable
    index={index}
    draggableId={String(week.id)}
    isDragDisabled={week.id === -1}
  >
    {provided => (
      <Flex
        ref={provided.innerRef}
        {...provided.draggableProps}
        column
        shrink="0"
        width="100%"
      >
        {week.id !== -1 ? (
          <WeekHeader
            week={week}
            workoutOptions={workoutOptions}
            dragHandleProps={provided.dragHandleProps}
            onAddWorkout={onAddWorkout}
            onCopy={onCopy}
            onUpdate={onUpdate}
            onRemove={onRemove}
          />
        ) : (
          <Flex
            width="100%"
            align="center"
            shrink="0"
            padding="10px"
            background="white"
          >
            <Text
              color="#797979"
              size="14px"
              weight="bold"
              nowrap
            >
              {week.name}
            </Text>
          </Flex>
        )}

        <Droppable
          type="workout"
          droppableId={String(week.id)}
        >
          {droppableProvided => (
            <WeekWorkouts
              workouts={week.workouts || []}
              selectedId={selectedWorkoutId}
              resourceType={resourceType}
              droppableProvided={droppableProvided}
              onSelectWorkout={onSelectWorkout}
            />
          )}
        </Droppable>
      </Flex>
    )}
  </Draggable>
));

export default Week;
